import { MyTeamEmployeeData } from '../../types'

export interface DayColumnData {
  hasNonBillable: boolean
  hasMissing: boolean
  billable: number
  nonBillable: number
  total: number
  utilization: number
}

const sum = (
  employees: MyTeamEmployeeData[],
  pick: (e: MyTeamEmployeeData) => number,
) => employees.reduce((acc, e) => acc + pick(e), 0)

export const buildDayColumn = (
  employees: MyTeamEmployeeData[],
  date: string,
): DayColumnData => {
  const hasHours = (e: MyTeamEmployeeData) => (e.dailyHours.get(date) || 0) > 0

  return {
    hasNonBillable: employees.some(
      (e) => hasHours(e) && e.dailyBillableStatus.get(date) === false,
    ),
    hasMissing: employees.some(
      (e) => hasHours(e) && e.dailyBillableStatus.get(date) === undefined,
    ),
    billable: sum(employees, (e) => e.dailyBillableHours.get(date) || 0),
    nonBillable: sum(employees, (e) => e.dailyNonBillableHours.get(date) || 0),
    total: sum(employees, (e) => e.dailyHours.get(date) || 0),
    utilization: employees.length
      ? Math.round(
          sum(employees, (e) => e.dailyUtilization.get(date) || 0) /
            employees.length,
        )
      : 0,
  }
}
